import { render, staticRenderFns } from "./BreadcrumbTemplate.vue?vue&type=template&id=66527834&scoped=true&"
import script from "./BreadcrumbTemplate.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./BreadcrumbTemplate.vue?vue&type=style&index=0&id=66527834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66527834",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem})
